var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cosmic",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"cosmic__sky"}),_c('div',{staticClass:"cosmic__stars"}),_c('div',{staticClass:"cosmic__aurora"}),_c('span',{staticClass:"cosmic__planet cosmic__planet--a"}),_c('span',{staticClass:"cosmic__planet cosmic__planet--b"}),_c('span',{staticClass:"cosmic__planet cosmic__planet--c"})])
}]

export { render, staticRenderFns }